import { createSlice } from '@reduxjs/toolkit'

// Order of the wizard; a new step is added here and registered in GroupLeaderEventSetupRoot.
export const STEPS = [ 'games', 'players', 'pairings', 'course_tee', 'review' ]

const wizardSlice = createSlice({
  name: 'wizard',
  initialState: {
    currentStep: 'games',
    completedSteps: [],
    roundId: null,
    setupConfig: null,
    gamesFormatFilter: 'individual',
  },
  reducers: {
    // Unguarded: the header jumps anywhere, and a step needing earlier output owns that check.
    goToStep: (state, action) => {
      state.currentStep = action.payload
    },
    markStepCompleted: (state, action) => {
      const step = action.payload
      if (!state.completedSteps.includes(step)) {
        state.completedSteps.push(step)
      }
    },
    goToNextStep: (state) => {
      const idx = STEPS.indexOf(state.currentStep)
      if (idx < STEPS.length - 1) {
        state.currentStep = STEPS[idx + 1]
      }
    },
    goToPreviousStep: (state) => {
      const idx = STEPS.indexOf(state.currentStep)
      if (idx > 0) {
        state.currentStep = STEPS[idx - 1]
      }
    },
    setRoundId: (state, action) => {
      state.roundId = action.payload
    },
    setSetupConfig: (state, action) => {
      state.setupConfig = action.payload
    },
    setGamesFormatFilter: (state, action) => {
      state.gamesFormatFilter = action.payload
    },
  },
})

export const {
  goToStep,
  markStepCompleted,
  goToNextStep,
  goToPreviousStep,
  setRoundId,
  setSetupConfig,
  setGamesFormatFilter,
} = wizardSlice.actions
export const wizardReducer = wizardSlice.reducer
